import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchAttributes = createAction(constants.FETCH_ATTRIBUTES)
export const fetchAttributesPending = createAction(constants.FETCH_ATTRIBUTES_PENDING)
export const fetchAttributesFailed = createAction(constants.FETCH_ATTRIBUTES_FAILED)
export const fetchAttributesCancelled = createAction(constants.FETCH_ATTRIBUTES_CANCELLED)
export const receiveAttributes = createAction(constants.RECEIVE_ATTRIBUTES)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/attribute/actions.js